// extracted by mini-css-extract-plugin
module.exports = {"newsfeed":"Wf-z"};